import React, { FC } from 'react'
import { SLogo, SLogoContainer, STitle, STitleBlock } from '@components/WhereToApply/SComponents'

interface ILogoContainerProps {
  title: string
}

const LogoContainer: FC<ILogoContainerProps> = ({ title }) => (
  <STitleBlock>
    <SLogoContainer>
      <SLogo />
    </SLogoContainer>
    <STitle>{title}</STitle>
  </STitleBlock>
)

export default LogoContainer
